export default __webpack_public_path__ + "static/media/s_l.6bdbbb35.wav";